import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../../../../types/types';
import { getUserChatId } from 'app/store/model/authUser/selectors/getIsUserChat';
import { getSortedComments } from 'app/view/react_components/base/components/Comments/selectors/getSortedComments';
import { chatCardDelete } from 'app/rest/effects/chats/chat/chatCardDelete';
import { joinToChat } from 'app/rest/effects/chats/chat/joinToChat';
import { getController } from 'app/store/constants';

export const onToggleChat = (
    cardId: TCardId,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        if (getController().blockerHelper.showSnoozeBlockerForDemo()) return;
        let chatId =  getUserChatId(getState(), cardId);
        if (chatId){
            dispatch(chatCardDelete(cardId, chatId));
        } else {
            const comments = getSortedComments(getState(), cardId);
            if (comments.length) {
                dispatch(joinToChat(comments.at(-1)));
            }
        }
    };
};
